
    <mat-form-field appearance="fill" class="full-width">
      <mat-label>{{ label | translate | titlecase }}</mat-label>
      <mat-icon *ngIf="prefixIcon" [svgIcon]="prefixIcon" matPrefix></mat-icon>

      <mat-select [formControl]="control" [multiple]="multiple">
        <div *ngIf="filterable" class="filter filter--sticky" fxLayout="row">
          <mat-icon
            matPrefix
            class="filter--margin"
            svgIcon="search"
          ></mat-icon>
          <input
            matInput
            placeholder="{{ 'filter' | translate | titlecase }}"
            type="text"
            autocomplete="off"
            [formControl]="filterControl"
            (keydown.Space)="$event.stopPropagation()"
          />
        </div>
        <button
          *ngIf="control.value && clear"
          (click)="onClear()"
          mat-button
          class="filter__clear"
        >
          {{ 'clear' | translate | uppercase }}
        </button>
        <mat-option
          *ngFor="let item of (filteredItems | async)"
          [value]="item.id"
        >
          <span *ngIf="translate"> {{ displayFn(item) | translate }} </span>
          <span *ngIf="!translate"> {{ displayFn(item) }} </span>
        </mat-option>
      </mat-select>
      <mat-error *ngIf="control.hasError('required')">
        {{ label | translate | titlecase }} {{ 'is-required' | translate }}
      </mat-error>
    </mat-form-field>
  